export const MAX_IMAGE_BYTES = 15 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 200 * 1024 * 1024;

export type StayMediaKind = "image" | "video";

export type StayMediaValidation =
  | { ok: true; kind: StayMediaKind }
  | { ok: false; error: "description_required" | "time_required" | "unsupported_type" | "image_too_large" | "video_too_large" };

export type StayMediaDraft = {
  file: File;
  description: string;
  time: string;
};

export type StayMediaItem = {
  id: string;
  reservationId: string;
  petId: string;
  day: string;
  time: string;
  description: string;
  storagePath: string;
  mediaKind: StayMediaKind;
  mimeType: string;
  fileSize: number;
  signedUrl: string;
};

export function validateStayMediaDraft({ file, description, time }: StayMediaDraft): StayMediaValidation {
  if (!description.trim()) return { ok: false, error: "description_required" };
  if (!time) return { ok: false, error: "time_required" };
  const kind = file.type.startsWith("image/") ? "image" : file.type.startsWith("video/") ? "video" : null;
  if (!kind) return { ok: false, error: "unsupported_type" };
  if (kind === "image" && file.size > MAX_IMAGE_BYTES) return { ok: false, error: "image_too_large" };
  if (kind === "video" && file.size > MAX_VIDEO_BYTES) return { ok: false, error: "video_too_large" };
  return { ok: true, kind };
}

export function buildStayMediaPath(
  reservationId: string,
  day: string,
  filename: string,
  id: string,
) {
  const extension = filename.split(".").pop()?.toLowerCase().replace(/[^a-z0-9]/g, "") || "bin";
  return `${reservationId}/${day}/${id}.${extension}`;
}
